import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { mergeMap } from 'rxjs/operators';
import { ReportContent } from '../../models/report-content';
import { BaseService, IServiceUrlConfig } from '../base/base.service';

@Injectable({
  providedIn: 'root',
})
export class ReportContentService extends BaseService<ReportContent> {
  public override http = inject(HttpClient);

  constructor() {
    super(inject(HttpClient), ReportContent);
  }

  public getContentReportCount() {
    return this.apiStrategy.getHeaders('application/json', true, false).pipe(
      mergeMap((headers) => {
        return this.http.get<{ count: number }>(this.getServiceUrl('open-report-count', { mgmt: true }), {
          headers,
        });
      }),
    );
  }

  protected getServiceUrl(entityId?: string, serviceUrlConfig?: IServiceUrlConfig): string {
    const url = this.generateServiceURL('report-content', entityId, serviceUrlConfig);
    return this.apiStrategy.getServiceUrl(url);
  }
}
